import {kSystemIcons} from "../../../constants/icons";
import {SystemPrimaryCustomButton, SystemTertiaryCustomButton} from "../../buttons/SystemCustomButton";
import {kButtonStyles} from "../../../constants/styles";
import {get_nested} from "../../../services/JsonHandler";
import {doesFrontendExerciserExist} from "../../../helpers/ExerciserHelper";
import LevelABlockDivider from "../../dividers/LevelABlockDivider";
import SystemCustomDivider from "../../dividers/SystemCustomDivider";

export default function LevelAExerciserSection({levelA, isBrevetDisplay, launchExerciser}) {
    // Used in

    const levelAIdentifier = get_nested(["identifier"], levelA, null)
    const hasBackendExerciser = get_nested(['hasExerciser'], levelA, false)
    const isExerciserPublished = get_nested(['publishExerciser'], levelA, false)
    const hasExerciser = doesFrontendExerciserExist(levelAIdentifier) && hasBackendExerciser && isExerciserPublished

    // BUILD
    if (!hasExerciser)
        return null
    return (
        <div className={"w-full flex flex-col justify-start items-center"}>
            <LevelABlockDivider />
            <div className={"w-full bg-primaryDark4/20 border-[1px] border-greyLight3 px-[12px] py-[12px] rounded-[12px]"}>
                <div className={"w-full flex flex-col justify-start items-start"}>
                    <div className={"w-full flex justify-between items-center"}>
                        <span className={"text-[16px] font-medium text-greyLight7"}>
                            {"4. M'exercer jusqu'à maitriser"}
                        </span>
                        {isBrevetDisplay
                            ? <SystemTertiaryCustomButton
                                label={"Lancer un exercice"}
                                isDisabled={false}
                                isLoading={false}
                                isFullWidth={false}
                                icon={kSystemIcons.medal}
                                sizeStyle={kButtonStyles.smallButtonStyle}
                                onButtonClick={launchExerciser} />
                            : <SystemPrimaryCustomButton
                                label={"Lancer un exercice"}
                                isDisabled={false}
                                isLoading={false}
                                isFullWidth={false}
                                icon={kSystemIcons.medal}
                                sizeStyle={kButtonStyles.smallButtonStyle}
                                onButtonClick={launchExerciser} />
                        }
                    </div>
                    <SystemCustomDivider color={"bg-greyLight3"} extraClass={"mt-[12px]"} />
                    <span className={"mt-[12px] text-[16px] text-greyLight9 font-medium whitespace-pre-line"}>
                        {"Passe à la vitesse supérieure pour devenir un expert sur ce savoir-faire. Ici, fini les propositions de réponses. Tu dois trouver tout seul le résultat pour chaque question."}
                    </span>
                </div>
            </div>
        </div>
    );
}